import { Role } from "../../../Helpers/AuthorizationDataProvider";

export enum TabStatus {
	Error = 'error',
	Loaded = 'loaded',
	Loading = 'loading',
}

export interface Props {
	filters?: string
}

export interface Renewal {
	mentor: User
	timeLeft: number
}

export interface User {
	firstName: string
	imageId: string
	isActive: boolean
	isDeleted: boolean
	lastName: string
	location: string
	reinvite: boolean
	rocketUserId: string
	role: string
	userId: string
}

export interface TableData {
	imageId: string
	isDeleted: boolean
	name: string
	timeLeft: number
	userId: string
}